export default __webpack_public_path__ + "static/media/b59.3f046047.png";